import { MauDanhGia as IMauDanhGia } from '@/services/MauDanhGia';
import { getMauDanhGia } from '@/services/MauDanhGia/maudanhgia';
import { useState } from 'react';

export default () => {
  const [danhSach, setDanhSach] = useState<IMauDanhGia.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<IMauDanhGia.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [edit, setEdit] = useState<boolean>(false);
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  
  const getMauDanhGiaModel = async () => {
    setLoading(true);
    const response = await getMauDanhGia({ page, limit, cond: {...cond} });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getMauDanhGiaModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    edit,
    setEdit,
    visibleForm,
  };
};
